<div class="source-container">
  <div class="mode-notebook-cell">
    <div class="mode-notebook-cell-header">IN [{{ exportedDatasetSource.executionCount }}]</div>
    <div class="mode-notebook-cell-label">Py</div>
    <div class="mode-notebook-editor-cell">
      <mode-code-highlight
        [lang]="'python'"
        [lineNumbers]="true"
        [query]="exportedDatasetSource.cellContent"
      ></mode-code-highlight>
    </div>
  </div>
</div>
<footer mode-tab-footer>
  <div><label>Source</label>Python output</div>
  <div><label>Output cell</label>{{ exportedDatasetSource.executionCount }}</div>
</footer>
